import { render } from "./product-stock.vue?vue&type=template&id=e7c848c4"
import script from "./product-stock.vue?vue&type=script&lang=js"
export * from "./product-stock.vue?vue&type=script&lang=js"

import "./product-stock.vue?vue&type=style&index=0&id=e7c848c4&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__